import { useMemo } from "react"
import { useDispatch } from "react-redux"
import { ScopedDataAccess } from "../Models/Client/DataAccess"
import { MainThunkDispatch } from "../Reducers"
import type {
    AutoSegmentationRequest,
    MLActionProcessor,
    ObjectTrackingRequest
} from "resha"
import {
    processAutoSegmentation,
    createObjectTrackingRequest,
    getObjectTrackingResult
} from "../Actions/API/MLActions"

export function useMLActionProcessor(
    dataAccess: ScopedDataAccess | undefined
): MLActionProcessor {
    const dispatch = useDispatch<MainThunkDispatch>()

    return useMemo(
        () => ({
            autoSegmentation: (req: AutoSegmentationRequest) => {
                if (dataAccess === undefined) {
                    throw Error("Data access permission is not set")
                }

                return dispatch(processAutoSegmentation(req, dataAccess))
            },
            createObjectTrackingRequest: (req: ObjectTrackingRequest) => {
                if (dataAccess === undefined) {
                    throw Error("Data access permission is not set")
                }

                return dispatch(createObjectTrackingRequest(req, dataAccess))
            },
            getObjectTrackingResult: (trackId: string) => {
                if (dataAccess === undefined) {
                    throw Error("Data access permission is not set")
                }

                return dispatch(getObjectTrackingResult(trackId, dataAccess))
            }
        }),
        [dataAccess, dispatch]
    )
}
